import { Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import CustomTable from "../../components/CustomTable/CustomTable";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import AddPastPresident from "./AddPastPresident";

const LeadershipCouncil = () => {
  const [showAddLeadershipCouncil, setShowAddLeadershipCouncil] =
    useState(false);
  const [leadershipCouncils, setLeadershipCouncils] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [leadershipCouncilToDelete, setLeadershipCouncilToDelete] = useState<
    string | null
  >(null);
  const [leadershipCouncilToEdit, setLeadershipCouncilToEdit] = useState<
    any | null
  >(null);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    getLeadershipCouncils();
  }, [currentPage]);

  const getLeadershipCouncils = () => {
    WebService.getAPI({
      action: `past-president/get-past-president?page=${currentPage}&limit=${itemsPerPage}`,
    })
      .then((res: any) => {
        // for (let i in res?.data?.data) {
        //   res.data.data[i].action = (
        //     <div>
        //       <PencilFill
        //         className="me-3 cursor-pointer"
        //         onClick={() => {
        //           setShowAddLeadershipCouncil(true);
        //           setLeadershipCouncilToEdit(res.data.data[i]);
        //         }}
        //         title="Edit"
        //       />
        //       <TrashFill
        //         color="#DC143C"
        //         className="cursor-pointer"
        //         onClick={() => handleDeleteEvent(res.data.data[i]._id)}
        //         title="Delete"
        //       />
        //     </div>
        //   );
        // }
        const formattedRows = res?.data?.data.map((item: any) => ({
          ...item,
          year: `${item.from_year} - ${item.to_year}`, // 👈 year formatting
          action: (
            <div>
              <PencilFill
                className="me-3 cursor-pointer"
                onClick={() => {
                  setShowAddLeadershipCouncil(true);
                  setLeadershipCouncilToEdit(item);
                }}
                title="Edit"
              />
              <TrashFill
                color="#DC143C"
                className="cursor-pointer"
                onClick={() => handleDeleteEvent(item._id)}
                title="Delete"
              />
            </div>
          ),
        }));
        setLeadershipCouncils(formattedRows);
        setTotalCount(res?.data?.pagination?.total);
      })
      .catch((err: any) => {});
  };

  const handleDeleteEvent = (leadershipCouncilId: string) => {
    setLeadershipCouncilToDelete(leadershipCouncilId);
    setShowDeleteModal(true);
  };

  return (
    <>
      <AddPastPresident
        show={showAddLeadershipCouncil}
        handleClose={() => {
          setShowAddLeadershipCouncil(false);
          setLeadershipCouncilToEdit(null);
          getLeadershipCouncils();
        }}
        data={leadershipCouncilToEdit}
      />
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={() => {
          if (leadershipCouncilToDelete) {
            WebService.deleteAPI({
              action: `past-president/delete-past-president/${leadershipCouncilToDelete}`,
            }).then(() => {
              setShowDeleteModal(false);
              getLeadershipCouncils();
            });
          }
        }}
        message="Are you sure you want to delete this past president?"
      />
      <div className="events-main">
        <Card className="event-card">
          <div className="d-flex justify-content-between">
            <div className="page-title">Past Presidents</div>
            <CustomButton
              isLoading={false}
              label="Add"
              onClick={() => {
                setLeadershipCouncilToEdit(null);
                setShowAddLeadershipCouncil(true);
              }}
              style={{ width: 100 }}
            />
          </div>
          <CustomTable
            columns={[
              { id: "name", label: "Name", minWidth: 170 },
              {
                id: "designation",
                label: "Designation",
                minWidth: 100,
                align: "center",
              },
              {
                id: "company_name",
                label: "Company",
                minWidth: 100,
                align: "center",
              },
              { id: "year", label: "Year", minWidth: 100, align: "center" },
              { id: "action", label: "Action", minWidth: 100, align: "center" },
            ]}
            rows={leadershipCouncils}
            totalCount={totalCount}
            currentPage={currentPage}
            pageSize={itemsPerPage}
            onPageChange={(page) => {
              setCurrentPage(page);
            }}
          />
        </Card>
      </div>
    </>
  );
};

export default LeadershipCouncil;
